import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "icon"]

  toggle() {
    const isOpen = !this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden", isOpen)
    this.iconTarget.style.transform = isOpen ? "rotate(0deg)" : "rotate(45deg)"
  }
}
